const SafetyIcon = () => {
  return (
    <svg
      style={{
        width: "2rem",
        height: "2rem",
      }}
      focusable="false"
      class="pub__svg-icon c21nsg2"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22 20V4H2v16h20zM20 6H4v12h3v-8h10v8h3V6zm-9 6H9v6h2v-6zm2 6h2v-6h-2v6z"
      ></path>
    </svg>
  );
};
export default SafetyIcon;
